import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { useAuth } from '@/contexts/auth-context'
import { useSignupStore } from '@/reducers'
import { CompleteRegistrationStandard } from './CompleteRegistrationStandard'
import { DarkModeMenu } from './DarkmodeSignUpPanel'
import { FormStates, PATH_TO_STEP, StateValue } from './FormStateMachine'
import SignupContentEmail from './SignupContentEmail'
import SignupContentPhoneNumber from './SignupContentPhoneNumber'
import SignupContentVerifyPhoneNumber from './SignupVerifyPhoneNumber'
import SignupDisclosure from './SignupDisclosure'
import SignupKYCQuestions from './SignupKYCQuestions'
import SignupOccupation from './SignupOccupation'
import SignupPersonalInformation from './SignupPersonalInformation'
import SignupAdditionalInformation1 from './SignupAdditionalInformation1'
import SignupAdditionalInformation2 from './SignupAdditionalInformation2'
import FraudWarningFollowUp from './FraudWarningFollowUp'

const FUTURA_HOST = 'https://futura.paytrie.com'

const getFormPanel = (state: StateValue) => {
  switch (state) {
    case FormStates.EMAIL:
      return <SignupContentEmail />
    case FormStates.PHONE:
      return <SignupContentPhoneNumber />
    case FormStates.VERIFY_PHONE:
      return <SignupContentVerifyPhoneNumber />
    case FormStates.DISCLOSURE:
      return <SignupDisclosure />
    case FormStates.PERSONAL_INFO:
      return <SignupPersonalInformation />
    case FormStates.OCCUPATION:
      return <SignupOccupation />
    case FormStates.ADDITIONAL_INFO:
      return <SignupAdditionalInformation1 />
    case FormStates.ADDITIONAL_INFO_PAGE2:
      return <SignupAdditionalInformation2 />
    case FormStates.FRAUD_WARNING_FOLLOW_UP:
      return <FraudWarningFollowUp />
    case FormStates.KYC_GENERATE_QUESTIONS:
      return <SignupKYCQuestions />
    case FormStates.COMPLETE:
      return <CompleteRegistrationStandard />
  }
}

export const SignupPanel = () => {
  const formState = useSignupStore.use.formState()
  const jumpTo = useSignupStore.use.jumpTo()
  const { isAuth } = useAuth()
  const location = useLocation()
  const appHost = import.meta.env.VITE_APPLICATION_URL

  useEffect(() => {
    const target =
      appHost === FUTURA_HOST && location.pathname === '/'
        ? FormStates.EMAIL
        : PATH_TO_STEP[location.pathname]
    if (target && target !== formState) {
      jumpTo(target)
    }
  }, [location.pathname, appHost, formState, jumpTo])

  return (
    <div
      data-testid="container-signup-panel"
      className="relative p-5 md:pt-20 md:pb-0 w-full"
    >
      {window.self === window.top && (
        <div
          data-testid="container-signup-darkmode"
          className="absolute top-4 right-0 md:top-10 md:right-0"
        >
          <DarkModeMenu showSignOutButton={isAuth} />
        </div>
      )}
      <div data-testid="container-signup-content" className="flex-grow">
        <div data-testid="container-signup-form">{getFormPanel(formState)}</div>
      </div>
    </div>
  )
}
